import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import Cardbox from "./Cardbox";
import Resultbox from "./Resultbox";
import Slider from "./Slider";
import { ButtonGroup } from "@material-ui/core";

const historyPoints = [];

export default function App() {
  return (
    <React.Fragment>
      <CssBaseline />
      <Quiz />
    </React.Fragment>
  );
}

function Quiz() {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [sliderColor, setSliderColor] = useState(0);

  const [sectionPoints, setSectionPoints] = useState({
    fat: 0,
    halfFat: 0,
    dry: 0,
    superDry: 0,
    discount: 0,
    removeLevel: 0,
    difficulty: 0,
  });

  const questions = [
    {
      question: "Vad skulle du säga att du har för hudtyp?",
      answers: [
        {
          q: "Fettig.",
          p: [{ fat: 2 }, { halfFat: 1 }, { dry: 0 }, { superDry: 0 }],
        },
        {
          q: "Halvt fettig hud, skinande.",
          p: [{ fat: 1 }, { halfFat: 2 }, { dry: 0 }, { superDry: 0 }],
        },
        {
          q: "Yttorr hud, lite sprickor.",
          p: [{ fat: 0 }, { halfFat: 0 }, { dry: 2 }, { superDry: 1 }],
        },
        {
          q: "Jättetorr, mycket sprickor.",
          p: [{ fat: 0 }, { halfFat: 0 }, { dry: 1 }, { superDry: 2 }],
        },
      ],
    },
    {
      question:
        "Tycker du det är viktigt att kunna få bort din brun utan sol enkelt?",
      answers: [
        {
          q: "Nej inte alls, bara den är brun!",
          p: [{ removeLevel: 0 }],
        },

        {
          q: "Nja det spelar ingen roll egentligen.",
          p: [{ removeLevel: 1 }],
        },

        {
          q: "Det är skönt att kunna ta bort det faktsikt.",
          p: [{ removeLevel: 2 }],
        },

        {
          q: "Superviktigt, vill ta bort direkt om det är fel!",
          p: [{ removeLevel: 3 }],
        },
      ],
    },
    {
      question: "Vad har du för hudton?",
      answers: [],
    },
    {
      question: "Är priset viktigare än resultatet?",
      answers: [
        {
          q: "Jag vill inte betala mycket alls för att bli brun",
          p: [{ discount: 1 }],
        },
        {
          q: "Det får kosta vad det kostar vill, bara jag blir snygg!",
          p: [{ discount: 0 }],
        },
      ],
    },
    {
      question: "Tycker du det är svårt att applicera brun utan sol?",
      answers: [
        {
          q: "Nej, det går superenkelt för mig!",
          p: [{ difficulty: 0 }],
        },
        {
          q: "Har lite svårigheter ibland, kan bli fläckar då och då..",
          p: [{ difficulty: 1 }],
        },
        {
          q: "Det är jättesvårt att ha få en jämn linje",
          p: [{ difficulty: 2 }],
        },
      ],
    },
  ];

  function goBack(currentNumber) {
    if (currentNumber >= 0) {
      let temp = Object.assign({}, sectionPoints);
      historyPoints[historyPoints.length - 1].forEach((element) => {
        temp[Object.keys(element)] -= element[Object.keys(element)];
        setSectionPoints(temp);
      });

      historyPoints.pop();
      setCurrentNumber(currentNumber);
    }
  }
  function goForward(currentNumber, points) {
    if (currentNumber <= questions.length) {
      historyPoints.push(points);
      setPoints(points);
      setCurrentNumber(currentNumber);
    }
  }

  function setPoints(points) {
    let temp = sectionPoints;
    points.forEach((element) => {
      temp[Object.keys(element)] += element[Object.keys(element)];
    });

    setSectionPoints(temp);
  }

  return (
    <div>
      {currentNumber === questions.length ? (
        <div>
          <Container maxWidth="sm">
            <Resultbox
              sectionPoints={sectionPoints}
              sliderColor={sliderColor}
            />
          </Container>
        </div>
      ) : (
        <Container maxWidth="sm">
          <Cardbox
            number={currentNumber + 1}
            question={
              currentNumber < questions.length
                ? questions[currentNumber].question
                : null
            }
          />

          {currentNumber < questions.length ? (
            questions[currentNumber].question.includes("för hudton") ? (
              <div>
                <Slider
                  sliderCb={(color) => {
                    setSliderColor(color);
                  }}
                />
                <Button
                  style={{
                    marginTop: 20,
                    width: "100%",
                    fontWeight: "bold",
                    backgroundColor: "#e38989",
                    color: "white",
                  }}
                  onClick={() => {
                    goForward(currentNumber + 1, []);
                  }}
                  variant="contained"
                >
                  Nästa
                </Button>
              </div>
            ) : (
              questions[currentNumber].answers.map((element) => {
                return (
                  <Button
                    style={{
                      marginTop: 20,
                      width: "100%",
                      fontWeight: "bold",
                      backgroundColor: "#e38989",
                      color: "white",
                    }}
                    onClick={() => {
                      goForward(currentNumber + 1, element.p);
                    }}
                    variant="contained"
                  >
                    {" "}
                    {element.q}
                  </Button>
                );
              })
            )
          ) : null}
          <Button
            onClick={() => {
              goBack(currentNumber - 1);
            }}
          >
            Föregående
          </Button>
        </Container>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/App.js